<template>
  <div class="language-switcher">
    <button
      class="language-switcher__button"
      @click="toggleLanguage"
    >
      {{ alternateLanguage.name }}
    </button>
  </div>
</template>

<script lang="ts">
  import { defineComponent, computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  export default defineComponent({
    name: 'LanguageSwitcher',
    setup() {
      const { locale } = useI18n()

      const languages = {
        no: { code: 'no', name: 'NO' },
        en: { code: 'en', name: 'EN' },
      }

      const alternateLanguage = computed(() => {
        return locale.value === 'no' ? languages.en : languages.no
      })

      const toggleLanguage = () => {
        const newLang = locale.value === 'no' ? 'en' : 'no'
        locale.value = newLang
        localStorage.setItem('userLanguage', newLang)
      }

      return {
        alternateLanguage,
        toggleLanguage,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .language-switcher {
    display: flex;
    align-items: center;

    &__button {
      background: none;
      border: none;
      padding: 0.25rem 0.5rem;
      cursor: pointer;
      color: var(--color-text);
      font-size: 0.875rem;
      border-radius: 4px;
      transition: all 0.2s ease;

      &:hover {
        background-color: var(--color-gray-100);
      }
    }
  }
</style>
